Util = require 'app/scripts/lib/util'
Controller = require 'app/scripts/controller'
Dialog = require 'app/scripts/views/lib/dialog'

module.exports.highlight = (highlight, scrollIntoView) ->
  if (parts = /^([a-z]+)-([a-f0-9]{24})$/.exec(highlight))?
    [all, type, id] = parts
    switch type
      when 'action', 'comment'
        @actionListView.setHighlight(id)
        if !@model.actionList.get(id)
          @showAllActions()
        if scrollIntoView
          @scrollToHighlight()

  return

# If the user clicks on a link that points to something on the card we're
# already looking at, don't do the whole navigation thing and instead just
# skip to running the highlight code
module.exports.interceptHighlightLink = (e) ->
  # So I'm not sure how exactly this happens, given that we've selected
  # for a[href], but we are getting error reports that indicate that
  # e.target.href is undefined sometimes
  if !e.target.href
    return

  url = Util.relativeUrl(e.target.href)
  cardUrl = Controller.getCardUrl(@model)
  if (parts = ///^ #{cardUrl} \# ([^\#]+) $///.exec(url))?
    [all, highlight] = parts
    if highlight
      Util.stop(e)

      # Toggle the hash off if we're already on this one
      if highlight == location.hash.substr(1)
        history.replaceState(null, null, location.pathname)
        @actionListView.setHighlight(null)
      else
        history.replaceState(null, null, location.pathname + "#" + highlight)
        @highlight(highlight, true)
  return

module.exports.scrollToHighlight = ->
  lastScroll = Date.now()

  cancelAnimationFrame(@scrollInterval)
  snapTo = null

  updateScroll = =>
    if Dialog.scrolledSince(lastScroll)
      return

    if (el = @$('.mod-highlighted')[0])?
      if !snapTo
        rect = el.getBoundingClientRect()
        if rect.top < 0
          snapTo = 'top'
        else if rect.top + rect.height > window.innerHeight
          snapTo = 'bottom'
        else
          snapTo = null


      if snapTo == 'top'
        el.scrollIntoView(true)
      else if snapTo == 'bottom'
        el.scrollIntoView(false)

      lastScroll = Date.now()

    @scrollInterval = @requestAnimationFrame(updateScroll)
    return

  updateScroll()
  return
